<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready"
            container-class="flex min-h-screen sm:min-h-0">
            <form
                v-if="hasRedirectUrl"
                method="POST"
                :action="params.redirect_url"
                class="hidden"
                ref="form"
            >
                <input type="hidden" name="token_type" :value="user.token_type">
                <input type="hidden" name="expires_in" :value="user.expires_in">
                <input type="hidden" name="access_token" :value="user.access_token">
                <input type="hidden" name="refresh_token" :value="user.refresh_token">
                <input type="hidden" name="device" :value="user.device">
            </form>
            <Portal to="spinner">
                <div v-if="loading"
                        class="fixed inset-0 flex flex-col items-center justify-center p-8 bg-background-80">
                    <div class="mb-20">
                        <BaseSpinner/>
                    </div>
                </div>
            </Portal>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthService from '@/services/AuthService'
import Layout from '@/components/Layout.vue'
import BaseSpinner from '@/components/Base/BaseSpinner.vue'

export default {
    components: {
        Layout,
        BaseSpinner,
    },
    data() {
        return {
            ready: true,
            loading: false,
            authService: new AuthService(),
        }
    },
    computed: {
        ...mapGetters({
            params: 'settings/get',
            provider: 'providers/selected',
            plan: 'packs/selected',
            user: 'user/authenticated',
            device: 'device/getDevice',
            redeem: 'packs/redeemed',
        }),
        hasRedirectUrl() {
            return typeof this.params.redirect_url !== 'undefined' && this.params.redirect_url !== null
        },
    },
    methods: {
        isAuthenticated() {
            return Object.keys(this.user).length !== 0
        },
        isProviderExternal() {
            return typeof this.provider !== 'undefined' && this.provider.is_external;
        },
        redirectToProviderFlow() {
            switch (this.provider.name.toLowerCase()) {
            case 'vodacom':
                window.location.replace(`http://vodacom-staging.simplestreamcdn.com/?redirect_url=${
                    encodeURIComponent(`${window.location.origin}/vodacom`)
                }`)
                // this is unnecessary for a native redirect
                // however, consistent-return linter will throw up a complaint
                return null
            case 'safaricom':
                return this.$router.push({ name: 'OTP' })
            case 'mtn':
                return this.$router.push({ name: 'MTN' })
            default:
                return this.$router.push({ name: 'Pack' })
            }
        },
        planSelected() {
            return typeof this.plan !== 'undefined' && this.plan !== null
        },
        isRedeemed() {
            return this.redeem;
        },
    },
    async mounted() {
        if (!this.isAuthenticated()) {
            return this.$router.push({ name: 'Register' })
        }

        const validSession = await this.authService.checkSession(this.params, this.user.access_token, this.device)

        if (!validSession) {
            this.$store.dispatch('user/logout')

            return this.$router.push({ name: 'Login' })
        }

        if (this.isProviderExternal() && (this.planSelected() || this.isRedeemed())) {
            return this.redirectToProviderFlow()
        }

        if (this.hasRedirectUrl) {
            this.loading = true
            return this.$refs.form.submit()
        }

        if (!this.planSelected()) {
            return this.$router.push({ name: 'Account' })
        }

        return this.$router.push({ name: 'Pack' })
    },
}
</script>
